export const CompanyName = {
  NATURA: 'NATURA',
  AVON: 'AVON',
}
